import { isEmpty } from "@visactor/vutils";

import { mergeSpec } from "@visactor/vutils-extension";

import { transformToGraphic } from "../../util/style";

export function transformLegendTitleAttributes(title) {
    var _a, _b;
    const transformedTitle = Object.assign({}, title);
    return isEmpty(title.style) || (transformedTitle.textStyle = transformToGraphic(title.style)), 
    isEmpty(title.textStyle) || mergeSpec(transformedTitle.textStyle, transformToGraphic(title.textStyle)), 
    (null === (_a = title.shape) || void 0 === _a ? void 0 : _a.style) && transformToGraphic(transformedTitle.shape.style), 
    (null === (_b = title.background) || void 0 === _b ? void 0 : _b.style) && transformToGraphic(transformedTitle.background.style), 
    transformedTitle;
}
//# sourceMappingURL=util.js.map
